<div class="container-fluid" (window:resize)="onResize($event)" [ngClass]="{ 'h-100': !loggedIn || isChromelessRoute, 'p-0': isChromelessRoute }">
  <div class="row flex-row flex-nowrap position-relative" [ngClass]="{ 'h-100': !loggedIn || isChromelessRoute }">
    <div class="col-auto px-0 mobile-view-menu" *ngIf="loggedIn && !isChromelessRoute">
      <div id="menu" class="collapse collapse-horizontal show border-end sticky-top">
        <div id="sidebar-nav" class="list-group border-0 rounded-0 text-sm-start sticky-top h-100 transition">
          <ng-container *ngIf="!isFixedAssetMenu">
            <a class="d-block link-dark text-decoration-none" title="" data-bs-toggle="tooltip" data-bs-placement="right" data-bs-original-title="Icon-only">
              <img [src]="domaninDetails?.userLogoSmall ? domaninDetails.userLogoSmall : defaultAppLogo" alt="ePortal" class="user-small-logo">
              <span [ngClass]="!expanded ? 'd-none' : 'd-inline'" class="menu-title">{{ "Menu.ePortal" | translate }}</span>
            </a>
            
            <div class="mobile-menu-tools d-md-none px-3 pb-2" *ngIf="!isExternalUser">
              <div class="mobile-menu-search-wrap">
                <input
                  type="text"
                  class="form-control mobile-menu-search"
                  [value]="mobileMenuSearchTerm"
                  (input)="onMobileSearchInput($event)"
                  [placeholder]="'Menu.searchInMenu' | translate"
                  [attr.aria-label]="'Menu.searchInMenu' | translate"
                />
                <button
                  type="button"
                  class="btn btn-link mobile-menu-search-clear"
                  *ngIf="mobileMenuSearchTerm"
                  (click)="clearMobileSearch()"
                  [attr.aria-label]="'Menu.clearSearch' | translate"
                >
                  <i class="bi bi-x-lg" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <ul class="nav nav-pills nav-flush flex-column flex-nowrap mb-auto">
              <li class="mb-2 d-md-none" *ngIf="!isExternalUser && recentMenuItems.length > 0 && !mobileMenuSearchTerm">
                <a
                  class="nav-link"
                  [ngClass]="{ 'active': isRecentMenuExpanded() }"
                  href="javascript:void(0)"
                  (click)="toggleRecentMenu()"
                >
                  <img src="/assets/tablerIcons/outline/star.svg" class="menu-image cursor-pointer" [title]="'Menu.recentlyUsed' | translate" />
                  <span class="menu-name cursor-pointer">{{ 'Menu.recentlyUsed' | translate }}</span>
                  <i class="bi d-md-none ms-auto" [ngClass]="isRecentMenuExpanded() ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </a>

                <ul class="list-unstyled mobile-submenu-inline d-md-none ps-4 mt-2"
                    *ngIf="isRecentMenuExpanded()"
                    [@slideDown]>
                  <li *ngFor="let recent of recentMenuItems">
                    <a
                      href="javascript:void(0)"
                      class="mobile-submenu-link mobile-recent-link d-block py-2 px-3 text-decoration-none"
                      (click)="navigateRecentItem(recent, $event)"
                    >
                      <img [src]="recent.angularIcon" class="menu-image mobile-recent-link-icon" alt="" />
                      <span class="mobile-recent-copy">
                        <span class="mobile-recent-name">{{ recent.name | titlecase }}</span>
                        <span class="mobile-recent-context" *ngIf="recent.parentName">
                          <img *ngIf="recent.parentIcon" [src]="recent.parentIcon" class="mobile-recent-context-icon" alt="" />
                          <span>{{ recent.parentName | titlecase }}</span>
                        </span>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>

              <li *ngFor="let item of (isExternalUser ? [] : (window.innerWidth <= 767 ? displayedMenu : menu))" id="main-{{ item.name.trim() }}" class="mb-2">
                <a
                  class="nav-link"
                  *ngIf="item.angularPageLink != null && item.angularPageLink != '/settings/basic-data' && shouldShowMenuItem(item)"
                  [ngClass]="{ 
                    'position-relative': item.name.trim() == 'MELDINGER' && messageCount > 0,
                    'active': isActive(item.angularPageLink) || (item.subMenu?.length && isMobileSubmenuExpanded(item.name))
                  }"
                  (click)="handleMenuClick(item, $event)"
                  [routerLink]="item.angularPageLink ? item.angularPageLink : null"
                  [target]="'_self'"
                >
                  <img [src]="item.angularIcon" class="menu-image cursor-pointer" [title]="item.name" />
                  <span class="badge badge-soft-secondary ms-1 message-count" *ngIf="item.name.trim() == 'MELDINGER' && messageCount > 0">{{ messageCount }}</span>
                  <span [ngClass]="!expanded ? 'd-none' : 'd-inline'" class="menu-name cursor-pointer">{{ item.name | titlecase }}</span>
                  <!-- Chevron for mobile submenu indicator -->
                  <i class="bi d-md-none ms-auto" 
                     *ngIf="item.subMenu?.length"
                     [ngClass]="isMobileSubmenuExpanded(item.name) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </a>
                
                <!-- MOBIL: undermeny direkte under parent item -->
                <ul class="list-unstyled mobile-submenu-inline d-md-none ps-4 mt-2" 
                    *ngIf="item.subMenu?.length && isMobileSubmenuExpanded(item.name)"
                    [@slideDown]>
                  <li *ngFor="let subItem of item.subMenu">
                    <ng-container *ngIf="subItem.isVisibleInMenu && adminPage(subItem.angularPageLink)">
                      <!-- Menu2 med menu3-underpunkter: navigerbar lenke + ekspander-pil -->
                      <ng-container *ngIf="subItem.subMenu?.length">
                        <div class="mobile-submenu-link d-flex align-items-center px-3"
                             [class.active]="isActive(subItem.angularPageLink) || hasActiveChild(subItem)">
                          <a class="flex-grow-1 py-2 text-decoration-none mobile-submenu-inner-link"
                             [class.active]="isActive(subItem.angularPageLink) || hasActiveChild(subItem)"
                             (click)="handleSubmenuClick(subItem, item, $event)"
                             href="javascript:void(0)">
                            <i class="bi me-1 bi-chevron-right"></i>
                            {{ subItem.name | titlecase }}
                          </a>
                          <button class="btn btn-link p-0 ms-2 mobile-menu3-toggle"
                                  (click)="toggleMenu3Submenu(item.name + '__' + subItem.name); $event.stopPropagation()">
                            <i class="bi" [ngClass]="isMobileSubmenuExpanded(item.name + '__' + subItem.name) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                          </button>
                        </div>
                        <!-- Menu3-items -->
                        <ul class="list-unstyled mobile-submenu-inline d-md-none ps-5 mt-1"
                            *ngIf="isMobileSubmenuExpanded(item.name + '__' + subItem.name)"
                            [@slideDown]>
                          <li *ngFor="let child of subItem.subMenu">
                            <a class="mobile-submenu-link d-block py-2 px-3 text-decoration-none"
                               [class.active]="isActive(child.angularPageLink)"
                               (click)="handleSubmenuClick(child, subItem, $event)"
                               href="javascript:void(0)">
                              <i class="bi bi-dot me-1"></i>
                              {{ child.name | titlecase }}
                            </a>
                          </li>
                        </ul>
                      </ng-container>
                      <!-- Menu2 uten underpunkter: intern lenke -->
                      <a
                        *ngIf="!subItem.subMenu?.length && subItem.angularPageLink && !subItem.angularPageLink.startsWith('http')"
                        class="mobile-submenu-link d-block py-2 px-3 text-decoration-none"
                        [class.active]="isActive(subItem.angularPageLink)"
                        (click)="handleSubmenuClick(subItem, item, $event)"
                        href="javascript:void(0)"
                      >
                        <i class="bi me-1" [ngClass]="isActive(subItem.angularPageLink) ? 'bi-chevron-right text-primary' : 'bi-chevron-right'"></i>
                        {{ subItem.name | titlecase }}
                      </a>
                      <!-- Menu2 ekstern lenke -->
                      <a
                        *ngIf="!subItem.subMenu?.length && subItem.angularPageLink && subItem.angularPageLink.startsWith('http')"
                        class="mobile-submenu-link d-block py-2 px-3 text-decoration-none"
                        [href]="subItem.angularPageLink" target="_blank"
                        (click)="closeMobileMenu()"
                      >
                        <i class="bi bi-box-arrow-up-right me-1"></i>
                        {{ subItem.name | titlecase }}
                      </a>
                    </ng-container>
                  </li>
                </ul>
                <!-- /MOBIL undermeny -->
              </li>
            </ul>

            <div class="mobile-menu-empty px-3 pb-2 d-md-none" *ngIf="mobileMenuSearchTerm && displayedMenu.length === 0">
              {{ 'Menu.noMenuResults' | translate }}
            </div>

            <div class="flex-shrink-1 mb-4">
              <ul class="nav nav-pills nav-flush flex-column flex-nowrap mb-auto">
                <li [routerLinkActive]="['active']" class="mb-2">
                  <a class="nav-link" (click)="logOut($event)">
                    <img class="menu-image cursor-pointer" src="/assets/tablerIcons/outline/power.svg">
                    <span [ngClass]="!expanded ? 'd-none' : 'd-inline'" class="menu-name cursor-pointer">{{ "Menu.logout" | translate }}</span>
                  </a>
                </li>
                <li [routerLinkActive]="['active']" class="mb-2">
                  <a class="nav-link"
                     (click)="handleBottomMenuClick('/my-profile', $event)"
                     href="javascript:void(0)">
                    <img class="menu-image cursor-pointer" src="/assets/tablerIcons/outline/user-circle.svg">
                    <span [ngClass]="!expanded ? 'd-none' : 'd-inline'" class="menu-name cursor-pointer">{{ "Menu.myProfile" | translate }}</span>
                  </a>
                </li>
                <li [routerLinkActive]="['active']" class="mb-2" *ngIf="!isExternalUser">
                  <a class="nav-link"
                     [ngClass]="{ 'active': isSettingsRoute() || isSettingsMenuExpanded() }"
                     (click)="handleSettingsMenuClick($event)"
                     href="javascript:void(0)">
                    <img src="/assets/tablerIcons/outline/settings.svg" class="menu-image cursor-pointer" />
                    <span [ngClass]="!expanded ? 'd-none' : 'd-inline'" class="menu-name cursor-pointer">{{ "Menu.setting" | translate }}</span>
                    <i class="bi d-md-none ms-auto"
                       *ngIf="getSettingsMenuItem()?.subMenu?.length"
                       [ngClass]="isSettingsMenuExpanded() ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  </a>

                  <ul class="list-unstyled mobile-submenu-inline d-md-none ps-4 mt-2"
                      *ngIf="getSettingsMenuItem()?.subMenu?.length && isSettingsMenuExpanded()"
                      [@slideDown]>
                    <li *ngFor="let subItem of getSettingsMenuItem().subMenu">
                      <ng-container *ngIf="subItem.isVisibleInMenu && adminPage(subItem.angularPageLink)">
                        <a
                          *ngIf="subItem.angularPageLink && !subItem.angularPageLink.startsWith('http')"
                          class="mobile-submenu-link d-block py-2 px-3 text-decoration-none"
                          [class.active]="isActive(subItem.angularPageLink)"
                          (click)="handleSubmenuClick(subItem, getSettingsMenuItem(), $event)"
                          href="javascript:void(0)"
                        >
                          <i class="bi me-1" [ngClass]="isActive(subItem.angularPageLink) ? 'bi-chevron-right text-primary' : 'bi-chevron-right'"></i>
                          {{ subItem.name | titlecase }}
                        </a>
                        <a
                          *ngIf="subItem.angularPageLink && subItem.angularPageLink.startsWith('http')"
                          class="mobile-submenu-link d-block py-2 px-3 text-decoration-none"
                          [href]="subItem.angularPageLink" target="_blank"
                          (click)="closeMobileMenu()"
                        >
                          <i class="bi bi-box-arrow-up-right me-1"></i>
                          {{ subItem.name | titlecase }}
                        </a>
                      </ng-container>
                    </li>
                  </ul>
                </li>
                <li class="d-none d-md-block menu-icon">
                  <a class="nav-link" (click)="toggleMenu()">
                    <img src="/assets/tablerIcons/outline/chevrons-right.svg" class="menu-image cursor-pointer" *ngIf="!expanded" alt="Minimer meny"/>
                    <img src="/assets/tablerIcons/outline/chevrons-left.svg" class="menu-image cursor-pointer" *ngIf="expanded" alt="Utvid meny"/>
                    <span [ngClass]="!expanded?'d-none':'d-inline'" class="menu-name cursor-pointer hidden-xs">{{environment.Version}}
                      <img src="/assets/tablerIcons/outline/bug.svg" class="menu-image-sm cursor-pointer" title="Rapporter feil" (click)="bugReportButton?.openBugReport(); $event.stopPropagation()" *ngIf="bugReportButton?.isEnabled"/>
                      <img src="/assets/tablerIcons/outline/sparkles.svg" class="menu-image-sm cursor-pointer" alt="AI info" [title]="'Menu.aboutAi' | translate" (click)="handleBottomMenuClick('/info/ai', $event); $event.stopPropagation()"/>
                      <a href="https://servicedesk.konti.no/support/solutions/articles/103000366155-versjonsnotater-eportal-time" title="Versjonsnotater" target="_blank" rel="noopener noreferrer">
                        <img src="/assets/tablerIcons/outline/help-hexagon.svg" class="menu-image-sm cursor-pointer" title="Versjonsnotater"/>
                      </a>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </ng-container>

          <ng-container *ngIf="isFixedAssetMenu">
            <a class="d-block link-dark text-decoration-none" title="" data-bs-toggle="tooltip" data-bs-placement="right" data-bs-original-title="Icon-only">
              <img [src]="domaninDetails?.userLogoSmall ? domaninDetails.userLogoSmall : defaultAppLogo" alt="ePortal" class="user-small-logo">
              <span [ngClass]="!expanded?'d-none':'d-inline'" class="menu-title">{{'Menu.ePortal' | translate}}</span>
            </a>

            <div class="mobile-menu-tools d-md-none px-3 pb-2" *ngIf="!isExternalUser">
              <div class="mobile-menu-search-wrap">
                <input
                  type="text"
                  class="form-control mobile-menu-search"
                  [value]="mobileMenuSearchTerm"
                  (input)="onMobileSearchInput($event)"
                  [placeholder]="'Menu.searchInMenu' | translate"
                  [attr.aria-label]="'Menu.searchInMenu' | translate"
                />
                <button
                  type="button"
                  class="btn btn-link mobile-menu-search-clear"
                  *ngIf="mobileMenuSearchTerm"
                  (click)="clearMobileSearch()"
                  [attr.aria-label]="'Menu.clearSearch' | translate"
                >
                  <i class="bi bi-x-lg" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <ul class="nav nav-pills nav-flush flex-column flex-nowrap mb-auto">
              <li class="mb-2 d-md-none" *ngIf="!isExternalUser && recentMenuItems.length > 0 && !mobileMenuSearchTerm">
                <a
                  class="nav-link"
                  [ngClass]="{ 'active': isRecentMenuExpanded() }"
                  href="javascript:void(0)"
                  (click)="toggleRecentMenu()"
                >
                  <img src="/assets/tablerIcons/outline/star.svg" class="menu-image cursor-pointer" [title]="'Menu.recentlyUsed' | translate" />
                  <span class="menu-name cursor-pointer">{{ 'Menu.recentlyUsed' | translate }}</span>
                  <i class="bi d-md-none ms-auto" [ngClass]="isRecentMenuExpanded() ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </a>

                <ul class="list-unstyled mobile-submenu-inline d-md-none ps-4 mt-2"
                    *ngIf="isRecentMenuExpanded()"
                    [@slideDown]>
                  <li *ngFor="let recent of recentMenuItems">
                    <a
                      href="javascript:void(0)"
                      class="mobile-submenu-link mobile-recent-link d-block py-2 px-3 text-decoration-none"
                      (click)="navigateRecentItem(recent, $event)"
                    >
                      <img [src]="recent.angularIcon" class="menu-image mobile-recent-link-icon" alt="" />
                      <span class="mobile-recent-copy">
                        <span class="mobile-recent-name">{{ recent.name | titlecase }}</span>
                        <span class="mobile-recent-context" *ngIf="recent.parentName">
                          <img *ngIf="recent.parentIcon" [src]="recent.parentIcon" class="mobile-recent-context-icon" alt="" />
                          <span>{{ recent.parentName | titlecase }}</span>
                        </span>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>

              <li *ngFor="let item of (isExternalUser ? [] : (window.innerWidth <= 767 ? displayedFixedAssetMenu : fixedAssetMenu))" id="main-{{item.name.trim()}}" class="mb-2">
                <a class="nav-link" 
                   [ngClass]="{ 'active': isActive(item.angularPageLink) || (item.subMenu?.length && isMobileSubmenuExpanded(item.name)) }"
                   (click)="handleMenuClick(item, $event)"
                   [routerLink]="item.angularPageLink ? item.angularPageLink : null"
                   [target]="'_self'">
                  <img [src]="item.angularIcon" class="menu-image cursor-pointer" [title]="item.name">
                  <span [ngClass]="!expanded?'d-none':'d-inline'" data-k="test" class="menu-name cursor-pointer">{{item.name | titlecase}}</span>
                  <!-- Chevron for mobile submenu indicator -->
                  <i class="bi d-md-none ms-auto" 
                     *ngIf="item.subMenu?.length"
                     [ngClass]="isMobileSubmenuExpanded(item.name) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </a>
                
                <!-- MOBIL: undermeny direkte under parent item -->
                <ul class="list-unstyled mobile-submenu-inline d-md-none ps-4 mt-2" 
                    *ngIf="item.subMenu?.length && isMobileSubmenuExpanded(item.name)"
                    [@slideDown]>
                  <li *ngFor="let subItem of item.subMenu">
                    <ng-container *ngIf="subItem.isVisibleInMenu && adminPage(subItem.angularPageLink)">
                      <a
                        *ngIf="subItem.angularPageLink && !subItem.angularPageLink.startsWith('http')"
                        class="mobile-submenu-link d-block py-2 px-3 text-decoration-none"
                        [routerLink]="subItem.angularPageLink"
                        [class.active]="isActive(subItem.angularPageLink)"
                        (click)="handleSubmenuClick(subItem, item, $event)"
                        target="_self"
                      >
                        <i class="bi me-1" [ngClass]="isActive(subItem.angularPageLink) ? 'bi-chevron-right text-primary' : 'bi-chevron-right'"></i>
                        {{ subItem.name | titlecase }}
                      </a>
                      <a
                        *ngIf="subItem.angularPageLink && subItem.angularPageLink.startsWith('http')"
                        class="mobile-submenu-link d-block py-2 px-3 text-decoration-none"
                        [href]="subItem.angularPageLink" target="_blank"
                        (click)="closeMobileMenu()"
                      >
                        <i class="bi bi-box-arrow-up-right me-1"></i>
                        {{ subItem.name | titlecase }}
                      </a>
                    </ng-container>
                  </li>
                </ul>
                <!-- /MOBIL undermeny -->
              </li>
            </ul>

            <div class="mobile-menu-empty px-3 pb-2 d-md-none" *ngIf="mobileMenuSearchTerm && displayedFixedAssetMenu.length === 0">
              {{ 'Menu.noMenuResults' | translate }}
            </div>

            <div class="flex-shrink-1 mb-4">
              <ul class="nav nav-pills nav-flush flex-column flex-nowrap mb-auto">
                <li [routerLinkActive]="['active']" class="mb-2">
                  <a class="nav-link" (click)="setFixedAssetMenu(false)">
                    <img class="menu-image cursor-pointer" src="/assets/tablerIcons/outline/clock.svg">
                    <span [ngClass]="!expanded?'d-none':'d-inline'" class="menu-name cursor-pointer">{{'Menu.timePortal' | translate}}</span>
                  </a>
                </li>
                <li [routerLinkActive]="['active']" class="mb-2">
                  <a class="nav-link" (click)="logOut()">
                    <img class="menu-image cursor-pointer" src="/assets/tablerIcons/outline/power.svg">
                    <span [ngClass]="!expanded?'d-none':'d-inline'" class="menu-name cursor-pointer">{{'Menu.logout' | translate}}</span>
                  </a>
                </li>
                <li class="d-none d-md-block menu-icon">
                  <a class="nav-link" (click)="toggleMenu()">
                    <img src="/assets/tablerIcons/outline/chevrons-right.svg" class="menu-image cursor-pointer" *ngIf="!expanded" alt="Minimer meny"/>
                    <img src="/assets/tablerIcons/outline/chevrons-left.svg" class="menu-image cursor-pointer" *ngIf="expanded" alt="Utvid meny"/>
                    <span [ngClass]="!expanded?'d-none':'d-inline'" class="menu-name cursor-pointer hidden-xs">{{environment.Version}}
                      <img src="/assets/tablerIcons/outline/bug.svg" class="menu-image-sm cursor-pointer" title="Rapporter feil" (click)="bugReportButton?.openBugReport(); $event.stopPropagation()" *ngIf="bugReportButton?.isEnabled"/>
                      <img src="/assets/tablerIcons/outline/sparkles.svg" class="menu-image-sm cursor-pointer" alt="AI info" [title]="'Menu.aboutAi' | translate" (click)="handleBottomMenuClick('/info/ai', $event); $event.stopPropagation()"/>
                      <a href="https://servicedesk.konti.no/support/solutions/articles/103000366155-versjonsnotater-eportal-time" title="Versjonsnotater" target="_blank" rel="noopener noreferrer">
                        <img src="/assets/tablerIcons/outline/help-hexagon.svg" class="menu-image-sm cursor-pointer" title="Versjonsnotater"/>
                      </a>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Mobile backdrop — click outside to close menu -->
    <div class="mobile-menu-backdrop d-md-none"
         *ngIf="mobileMenuOpen"
         (click)="closeMobileMenu()"></div>

    <div class="col-sm position-relative" [ngClass]="{ 'content pb-4': !isChromelessRoute }">
      <div class="row" [ngClass]="{ 'h-100': !loggedIn || isChromelessRoute }">
        <div class="col-12" *ngIf="loggedIn && !isChromelessRoute">
          <!-- Mobile topbar med logo, midtstilt tittel, og hamburger -->
          <div class="mobile-topbar-row d-flex d-md-none align-items-center">
            <div class="mobile-logo-container">
              <img [src]="domaninDetails?.userLogoSmall ? domaninDetails.userLogoSmall : defaultAppLogo" alt="ePortal" class="user-small-logo">
            </div>
            <div class="mobile-title-container">
              <span class="current-menu-mobile" *ngIf="getCurrentMenuTitle()">{{ getCurrentMenuTitle() }}</span>
            </div>
            <div class="mobile-menu-toggle-container">
              <button type="button" data-bs-target="#menu" data-bs-toggle="collapse" (click)="setIcon()" class="btn btn-mobile-hamburger">
                <img src="/assets/tablerIcons/outline/menu-2.svg" class="menu-image cursor-pointer" alt="Meny"/>
              </button>
            </div>
          </div>

          <div class="d-none d-md-flex mb-2 align-items-center menu-padding">
            <div class="current-menu flex-grow-1">
              <span class="ps-2" *ngIf="getCurrentMenuTitle()">{{ getCurrentMenuTitle() }}</span>
            </div>
            <div class="d-flex align-items-center gap-2 flex-shrink-0">
              <app-global-search *ngIf="domaninDetails?.useGlobalSearch"></app-global-search>
              <!-- Notification Bell Component (includes Bug Report buttons) -->
              <app-notification-bell></app-notification-bell>
              <!-- Tenant Switcher - Top Header Version -->
              <app-tenant-selector-header *ngIf="!isExternalUser"></app-tenant-selector-header>
              <!-- User Logo -->
              <img [src]="domaninDetails?.userLogo ? domaninDetails.userLogo : defaultAppCustomerLogo" alt="ePortal" class="user-logo">
            </div>
          </div>

          <!-- HEADER under-meny: skjules på mobil -->
          <div class="row sub-menu" *ngIf="!isExternalUser">
            <div class="col-lg-8 col-md-12 d-none d-md-block">
              <div class="desktop-submenu" *ngIf="currentMenu">
                <ng-container *ngFor="let item of currentMenu.subMenu">
                  <ng-container *ngIf="item.isVisibleInMenu && adminPage(item.angularPageLink)">
                    <!-- Menu2 with Menu3 children → hover dropdown -->
                    <div class="submenu-dropdown" ngbDropdown #dd="ngbDropdown"
                         placement="bottom-start" [autoClose]="false"
                         (mouseenter)="dd.open()" (mouseleave)="dd.close()"
                         *ngIf="item.subMenu?.length > 0">
                      <a class="submenu-item"
                         ngbDropdownAnchor
                         [routerLink]="item.angularPageLink"
                         [class.active]="isActive(item.angularPageLink) || hasActiveChild(item)"
                         target="_self">
                        <img [src]="item.angularIcon || '/assets/tablerIcons/outline/apps.svg'" class="submenu-icon" alt="" />
                        <span *ngIf="!isSettingsItem(item)">{{ item.name | titlecase }}</span>
                        <i class="bi bi-chevron-down submenu-chevron"></i>
                      </a>
                      <div ngbDropdownMenu class="submenu-dropdown-menu">
                        <a ngbDropdownItem
                           *ngFor="let child of item.subMenu"
                           [routerLink]="child.angularPageLink"
                           [class.active]="isActive(child.angularPageLink)">
                          {{ child.name | titlecase }}
                        </a>
                      </div>
                    </div>
                    <!-- Menu2 without children → plain link (internal) -->
                    <a
                      [routerLink]="item.angularPageLink"
                      [class.active]="isActive(item.angularPageLink)"
                      *ngIf="!item.subMenu?.length && item.angularPageLink && !item.angularPageLink.startsWith('http')"
                      class="submenu-item"
                      target="_self"
                    >
                      <img [src]="item.angularIcon || '/assets/tablerIcons/outline/apps.svg'" class="submenu-icon" alt="" />
                      <span *ngIf="!isSettingsItem(item)">{{ item.name | titlecase }}</span>
                    </a>
                    <!-- Menu2 without children → external link -->
                    <a
                      [href]="item.angularPageLink" target="_blank"
                      *ngIf="!item.subMenu?.length && item.angularPageLink && item.angularPageLink.startsWith('http')"
                      class="submenu-item"
                    >
                      <img [src]="item.angularIcon || '/assets/tablerIcons/outline/external-link.svg'" class="submenu-icon" alt="" />
                      <span>{{ item.name | titlecase }}</span>
                    </a>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <div class="col-lg-4 col-md-12">
              <nav aria-label="breadcrumb">
              <ol class="breadcrumb bredcrumb-nav float-lg-end ps-2">
                <li class="breadcrumb-item">
                  <a routerLink="/home" target="_self" *ngIf="!isFixedAssetMenu" [attr.title]="'Menu.home' | translate">
                    <i class="bi bi-house-door" aria-hidden="true"></i>
                    <span class="visually-hidden">{{ 'Menu.home' | translate }}</span>
                  </a>
                  <a routerLink="/fixed-asset/dashboard" target="_self" *ngIf="isFixedAssetMenu" [attr.title]="'Menu.home' | translate">
                    <i class="bi bi-house-door" aria-hidden="true"></i>
                    <span class="visually-hidden">{{ 'Menu.home' | translate }}</span>
                  </a>
                </li>
                <li *ngFor="let breadcrumb of breadcrumbs; let last = last" class="breadcrumb-item" [class.active]="last">
                  <a *ngIf="!last" [routerLink]="[breadcrumb.url, breadcrumb.params]" target="_self">{{ breadcrumb.label | titlecase }}</a>
                  <span *ngIf="last">{{ breadcrumb.label | titlecase }}</span>
                </li>
              </ol>
              </nav>
            </div>
          </div>

          <div class="row help-class" style="display: none">
            <div class="col-12 text-sm-end mt-2 mb-2">
              <a href="#" class="ps-3">
                <img src="/assets/angularIcons/help.png" class="menu-image vertical-middle" /> {{ "Menu.help" | translate }}
              </a>
            </div>
          </div>
        </div>

        <div [ngClass]="{ 'col-12 mt-2': !isChromelessRoute, 'h-100': !loggedIn || isChromelessRoute }">
          <div [ngClass]="{ 'h-100': !loggedIn || isChromelessRoute }">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
